// playerAdapterConstants.js
'use strict';

/** @example adapter.on(PlayerAdapterEvent.MUTED, () => { ... }); */
export const PlayerAdapterEvent = Object.freeze({
  PLAYING: 'playing',
  PAUSED: 'paused',
  ENDED: 'ended',
  READY: 'ready',
  ERROR: 'error',
  MUTED: 'muted',
  UNMUTED: 'unmuted',
  VOLUME_CHANGED: 'volumeChanged',
  SEEK: 'seek',
  SEEKED: 'seeked',
  STALL_STARTED: 'stallStarted',
  STALL_ENDED: 'stallEnded',
  TIME_CHANGED: 'timeChanged',
});
